import { Controller } from "stimulus";
// TODO split logics into different controllers in order to avoid complicated/multi-purpose controllers
export default class extends Controller {
  static targets = ['submitBtn', 'form'];

  submit(e) {
    console.log(`value is ${e.currentTarget.value}`);
    this.submitBtnTarget.click();
  }
  submitForm() {
    this.formTarget.requestSubmit()
  }
}
